import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/views/Login";
import Register from "@/views/Register";
import App from "@/App";
import Doctor from "@/views/Doctor";

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        redirect: "/register",
        component: App
    },
    {
        path: "/register",
        component: Register
    },
    {
        path: "/login",
        component: Login
    },
    {
        path: '/doctor/:id',
        component: Doctor
    }
]

const router = new VueRouter({
    routes
})

export default router
